export const COUNTRIES_DATA: string[] = ['Deutschland', 'Österreich', 'Schweiz'];
